import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import {
  dashboardOptionsNonStore,
  dashboardOptionsStore,
} from "./dashboardOptions";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { FaCaretDown } from "react-icons/fa";
import Select from "react-dropdown-select";
import { AnimatePresence, motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthContext";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import moment from "moment";
import DatePicker from "../../components/FormFields/DatePicker";

const Dashboard = () => {
  const { data = {}, apiCall } = useApi();
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(
    moment().subtract({ days: 7 }).toDate()
  );
  const [endDate, setEndDate] = useState(new Date());

  const onClickRaiseRequest = () => {
    navigate("/raisearequest");
  };

  const onClickSubmit = () => {
    navigate("/vouchers/submit", {state: {isEditFeatureOn: false}});
  };
  const {
    user: { userLabel, username },
    user,
    selectedStores,
    setCurrentTabSelect,
    storeDropdownState
  } = useAuth();
  const isStore = userLabel === "Store";
  const isL1 = userLabel === "L1";
  const isL2 = userLabel === "L2";
  const isL3 = userLabel === "L3";

  const getArrayOfSelectedStores = (selectedStoreOption) =>{
    if(selectedStoreOption?.storeDetails?.storeCode === undefined){
      return [storeDropdownState?.[0]?.storeCode]
    }else if(selectedStoreOption?.storeDetails?.storeCode !== 'All'){
      return [selectedStoreOption?.storeDetails?.storeCode]
    }else{
      let storeCodeArray = [];
      storeDropdownState?.forEach((item)=>{
        storeCodeArray?.push(item?.storeCode)
      })
      return storeCodeArray
    }
  }

  const dashboardApiCall = (start, end, selectedStores, singleStore) =>
    apiCall({
      url: apiUrls.dmsService.getDashboardData,
      method: "post",
      dataToSend: {
        startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(end || start)
          .endOf("d")
          .format("YYYY-MM-DD HH:mm:ss"),
          storeCodes: getArrayOfSelectedStores(selectedStores)
      },
    });

  useEffect(() => {
    if((!isStore && selectedStores[0]?.storeCode) || selectedStores?.storeDetails?.storeCode){
      dashboardApiCall(startDate, endDate, selectedStores, username);
    }
    if(isStore){
      dashboardApiCall(startDate, endDate, selectedStores, username);
    }
  }, [selectedStores, username]);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end !== null) dashboardApiCall(start, end, selectedStores);
  };

  const submittedVouchersList =
    !isStore && data?.managerDashboardResponse
      ? [
          {
            key:
              "All Stores - " +
              data?.managerDashboardResponse?.submittedVouchers,
            value:
              "All Stores - " +
              data?.managerDashboardResponse?.submittedVouchers,
          },
          ...data?.managerDashboardResponse?.storeWiseDashboardData?.map(
            (item) => ({
              key: `${item?.store} - ${item?.submittedVouchers}`,
              value: `${item?.store} - ${item?.submittedVouchers}`,
            })
          ),
        ]
      : [];

  return (
      <div
        // initial={{ y: 10, opacity: 0 }}
        // animate={{ y: 0, opacity: 1 }}
        // exit={{ y: -10, opacity: 0 }}
        // animate={{ x: 100 }}
        // transition={{ ease: "easeOut", duration: 0.5 }}
      >
        <div className="dashboard-container">
          <ToolbarHeader
            title="Dashboard"
            showBack={false}
            containerClassName="mt-14"
            renderRight={() => {
              return (
                <div className="flex items-center gap-x-3">
                  <div className="font-size-medium">Date Range</div>
                  <DatePicker
                    wrapperClassName="bg-white"
                    startDate={startDate}
                    endDate={endDate}
                    onChange={onChangeDate}
                    maxDate={new Date()}
                    dateRange
                  />
                </div>
              );
            }}
          />
          <div className="flex flex-wrap justify-between mt-10">
            {(userLabel === "Store"
              ? dashboardOptionsStore
              : dashboardOptionsNonStore
            ).map((item, index) => {
              return (
                <div
                  className={`dashboard-option mt-4 ${item?.cs || ""}`}
                  key={"dashboard-option-" + index}
                  onClick={() => {
                    if (item?.link) {
                      navigate(item.link);
                    }
                    item?.tab && setCurrentTabSelect(item.tab || {});
                  }}
                >
                  <img
                    src={item.icon}
                    className="w-[7.4rem] h-[7.4rem]"
                    alt="dashboard option icon"
                  />
                  <div className="font-size-small font-family-medium mt-4">
                    {item.title}
                  </div>

                  {item?.showOptions &&
                  !isStore &&
                  submittedVouchersList?.length &&
                  !selectedStores?.storeDetails ? (
                    <Select
                      dropdownGap={-8}
                      wrapperClassName="!w-[100%]"
                      className="!border-[0px] !w-[24rem]"
                      options={submittedVouchersList}
                      labelField="key"
                      valueField="value"
                      contentRenderer={() => {
                        return (
                          <div className="flex items-center justify-center gap-x-3 !w-[100%]">
                            <div className="text-[2.4rem] text-[var(--appColor)] font-family-medium mt-2">
                              ₹{" "}
                              {
                                Number(data?.["managerDashboardResponse"]?.[
                                  item.apiKey
                                ] || 0).toFixed(2) || "0"
                              }
                            </div>

                            {item.showOptions && (
                              <FaCaretDown
                                size={22}
                                color="var(--appColor)"
                                className="mt-3"
                              />
                            )}
                          </div>
                        );
                      }}
                      itemRenderer={(item) => {
                        return (
                          <div className={"font-size-small my-2 px-8"}>
                            {item.item.key}
                          </div>
                        );
                      }}
                      dropdownHandle={false}
                    />
                  ) : (
                    <div className="text-[2.4rem] text-[var(--appColor)] font-family-medium mt-2">
                      ₹{" "}
                      {
                        Number(data?.[
                          !isStore
                            ? "managerDashboardResponse"
                            : "storeDashboardResponse"
                        ]?.[item.apiKey] || 0).toFixed(2) || "0"
                      }
                    </div>
                  )}
                  {!isStore && item?.title === "Submitted Vouchers" && (
                    <div className="h-[6px] text-[#808080] text-[1.2rem]">
                      {data?.managerDashboardResponse?.submittedCountText}
                    </div>
                  )}
                </div>
              );
            })}
            {userLabel ? (
              <>
                {isStore ? (
                  <div className="flex justify-between w-[100%] mt-10">
                    <CustomButton
                      title="Raise A Request"
                      wrapperClassName="!h-[7rem] !w-[48%] font-family-medium"
                      textClassName="!text-[2.4rem]"
                      onClick={onClickRaiseRequest}
                    />
                    <CustomButton
                      title="Submit Your Vouchers"
                      wrapperClassName="!h-[7rem] !w-[48%]"
                      textClassName="!text-[2.4rem] font-family-medium"
                      onClick={onClickSubmit}
                    />
                  </div>
                ) : (
                  <div className="flex justify-between w-[100%] mt-10 gap-x-5">
                    {userLabel === "L1" && (
                      <CustomButton
                        title="Approve Store Request"
                        wrapperClassName="!h-[7rem] flex-1 font-family-medium"
                        textClassName="!text-[2.4rem]"
                        onClick={() => {
                          navigate("/request");
                        }}
                      />
                    )}
                    <CustomButton
                      title="Approve Vouchers"
                      wrapperClassName="!h-[7rem] flex-1 !w-[48%]"
                      textClassName="!text-[2.4rem] font-family-medium"
                      onClick={() => {
                        navigate("/vouchers");
                      }}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>
        </div>
      </div>
  );
};

export default Dashboard;
